import _ from 'underscore';
import { generateGuid } from '@bingads-webui-universal/primitive-utilities';
import {
  DATA_SOURCE_KEY_MAPPING,
  getDataSourceByKeys,
  getAttributesFromSiteConfig,
  getAttributesFromSnapshot,
  createWebsiteSourceData,
} from '@bingads-webui-campaign-react/smart-component-util';

export const SmartPageAction = {
  None: 'None',
  EnableCampaigns: 'EnableCampaigns',
  PauseCampaigns: 'PauseCampaigns',
  UpsertLeadTracking: 'UpsertLeadTracking',
};

export const SmartPageStatus = {
  Published: 'Published',
  Offline: 'Offline',
  Deleted: 'Deleted',
  Draft: 'Draft',
  PendingPublish: 'PendingPublish',
  UnpublishedChanges: 'UnpublishedChanges',
};

export const isSmartPagePublished = (smartpageData) => {
  if (_.isEmpty(smartpageData) || _.isEmpty(smartpageData.status)) {
    return false;
  }

  return smartpageData.status === SmartPageStatus.Published
    || smartpageData.status === SmartPageStatus.PendingPublish
    || smartpageData.status === SmartPageStatus.UnpublishedChanges;
};

export const siteConfigToModel = (siteConfig, action = SmartPageAction.None, serverContext) => {
  const attrs = getAttributesFromSiteConfig(siteConfig);
  const snapshotAttrs = getAttributesFromSnapshot(siteConfig.snapshots);

  const [
    businessName,
    businessDescription,
    businessCategories,
  ] = getDataSourceByKeys(siteConfig, [
    DATA_SOURCE_KEY_MAPPING.BusinessName,
    DATA_SOURCE_KEY_MAPPING.BusinessDescription,
    DATA_SOURCE_KEY_MAPPING.BusinessCategories,
  ]);
  const subDomain = siteConfig.subDomain || generateGuid();
  const descriptionFromCategory = businessCategories && businessCategories.join(', ');
  const description = businessDescription || descriptionFromCategory || '';

  const {
    uetTagId,
    isMTagMigrated,
    status,
    images,
    smartPageDataContext,
    migrationContext,
  } = siteConfig;

  const model = {
    '@odata.type': '#Model.SmartPage',
    Name: businessName,
    Description: description,
    SubDomain: subDomain,
    SiteSuffix: '',
    UetTagId: uetTagId,
    IsMTagMigrated: isMTagMigrated,
    Attributes: attrs,
    Snapshots: snapshotAttrs,
    Status: status || SmartPageStatus.Draft,
    ImageIds: _.uniq(_.pluck(images, 'IdString')),
    SmartPageDataContext: smartPageDataContext,
    Action: action,
    WebsiteSourceData: createWebsiteSourceData(siteConfig, serverContext),
    WSDMigrationContext: migrationContext,
  };

  return model;
};
